import { render, staticRenderFns } from "./FlyerThumbButton.vue?vue&type=template&id=400421ca"
import script from "./FlyerThumbButton.vue?vue&type=script&lang=js"
export * from "./FlyerThumbButton.vue?vue&type=script&lang=js"
import style0 from "./FlyerThumbButton.vue?vue&type=style&index=0&id=400421ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports